import { transform, isObject } from 'lodash';

export const replaceKeysDeep = (obj, keysMap) => transform(obj, (result: any, value, key) => { // transform to a new object
  const currentKey = keysMap[key] || key; // if the key is in keysMap use the replacement, if not use the original key
  // eslint-disable-next-line no-param-reassign
  result[currentKey] = isObject(value) ? replaceKeysDeep(value, keysMap) : value;
});
